<template>
<v-dialog v-model="dialogDetailTask" persistent max-width="550" style="overflow-y: hidden;" class="CSChatThai">
  <v-card style="border-radius:15px;">
    <v-card tile flat>
      <v-toolbar card class="toolbar-card-v2">
        <v-toolbar-title class="CSChatThai">
          <span >{{$t('Task.detail.header')}}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <header class="headerUser" id="headerMenubarUser" v-if="!edit">
           <nav class="headerUser__nav" >
             <ul class="headerUser__navbar">
               <li class="headerUser__item">
                 <a href="#" class="headerUser__link">
                   <button class="headerUser--btn" key="off" @click="show = !show">
                     <v-icon  class="headerUser--icon">more_vert</v-icon>
                    </button>
                 </a>
                 <transition name="dropdown">
                   <div class="headerUser__dropdown-menu" v-bind:class="{ active: show }" v-if="show">
                     <ul class="headerUser__dropdown-menu-nav">
                       <li class="header__dropdown-menu-item" @click="clickedit()">
                         <a href="#" class="header__dropdown-menu-link">
                           <div class="header__dropdown-menu-svg">
                             <v-icon meduim class="header--icon--menu font-size15">mdi-pencil</v-icon>
                           </div>
                           <div class="header__dropdown-menu-text">
                             {{$t('Task.detail.menu.edit')}}
                           </div>
                         </a>
                       </li>
                       <li class="header__dropdown-menu-item" @click="delete_task">
                         <a href="#" class="header__dropdown-menu-link">
                           <div class="header__dropdown-menu-svg">
                             <v-icon meduim class="header--icon--menu font-size15">far fa-trash-alt</v-icon>
                           </div>
                           <div class="header__dropdown-menu-text">
                             {{$t('Task.detail.menu.delete')}}
                           </div>
                         </a>
                       </li>
                     </ul>
                   </div>
                 </transition>
               </li>
             </ul>
           </nav>
         </header>
        <v-btn dark icon flat @click="closeDialog">
          <v-icon style="color: black !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card-text v-if="edit" style="height: 70vh;" class="scrolling-wrapper">
        <v-layout row wrap>
          <v-flex sm4 md4 xl4 lg4 class="textSubject">
            <span>{{$t('Task.create.subject')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top: 10px;">
            <input type="text" :placeholder="$t('Task.create.placeholderSubject')" class="CSChatThai inputtaskweb" v-model="subject_task">
          </v-flex>
          <v-flex sm4 md4 xl4 lg4 class="textSubject">
            <span>{{$t('Task.create.priority')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top:20px;">
              <v-btn flat :class="(priority=='1')? 'selectedPriority': ''" style="text-transform: none;" @click="priority = '1';">
                <v-icon class="btn-pri1">mdi-checkbox-blank</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('Task.create.p1')}}
              </v-btn>
              <v-btn flat :class="(priority=='2')? 'selectedPriority': ''" style="text-transform: none;" @click="priority = '2';">
                <v-icon class="btn-pri2">mdi-checkbox-blank</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('Task.create.p2')}}
              </v-btn>
              <v-btn flat :class="(priority=='3')? 'selectedPriority': ''" style="text-transform: none;" @click="priority = '3';">
                <v-icon class="btn-pri3">mdi-checkbox-blank</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('Task.create.p3')}}
              </v-btn>
          </v-flex>
          <v-flex sm4 md4 xl4 lg4 class="textSubject">
            <span>{{$t('Task.create.startDate')}}<span style="color: red;">*</span> :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8>
            <v-menu
                ref="menu1"
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="40"
                :return-value.sync="start_date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                style="width: 25%;"
              >
              <v-text-field
                slot="activator"
                v-model="start_date"
                label=""
                readonly
              ></v-text-field>
              <v-date-picker
              v-model="start_date"
              no-title scrollable
              :allowed-dates="allowedDates"
              :locale="$t('Task.allTask.localepicker')"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu1 = false" style="text-transform: none;">{{$t('AnswerQuestion.cancel')}}</v-btn>
                <v-btn flat color="primary" @click="$refs.menu1.save(start_date)" style="text-transform: none;">{{$t('AnswerQuestion.ok')}}</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm4 md4 xl4 lg4 class="textSubject">
            <span>{{$t('Task.create.endDate')}}<span style="color: red;">*</span> :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8>
            <v-menu
                ref="menu2"
                :close-on-content-click="false"
                v-model="menu2"
                :nudge-right="40"
                :return-value.sync="end_date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                style="width: 25%;"
              >
              <v-text-field
                slot="activator"
                v-model="end_date"
                label=""
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="end_date"
                no-title scrollable
                :allowed-dates="allowedDatesEnd"
                :min="min_date_end"
                :locale="$t('Task.allTask.localepicker')"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu2 = false" style="text-transform: none;">{{$t('AnswerQuestion.cancel')}}</v-btn>
                <v-btn flat color="primary" @click="$refs.menu2.save(end_date)" style="text-transform: none;">{{$t('AnswerQuestion.ok')}}</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm4 md4 xl4 lg4 class="textSubject">
            <span>{{$t('Task.create.description')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top: 20px;">
            <v-textarea
              :label="$t('Task.create.placeholderDescription')"
              solo
              no-resize
              style="width: 75%;"
              outline
              height="80"
              rows=3
              hide-details
              v-model="detail_task"
            ></v-textarea>
          </v-flex>
          <v-flex sm4 md4 xl4 lg4 class="textSubject">
            <span>{{$t('Task.create.assign')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8>
            <v-autocomplete
              :items="member"
              v-model="selectemember"
              :label="$t('Task.create.placeholderAssign')"
              item-text="name"
              item-value="tokenuser"
              multiple
              chips
              :menu-props="{maxHeight:'auto'}"
              style=" width: 75%;"
            >
              <template slot="selection" slot-scope="data">
                <v-chip
                  :selected="data.selectemember"
                  :key="JSON.stringify(data.item)"
                  close
                  class="chip--select-multi"
                  @input="data.parent.selectItem(data.item)"
                  v-if="data.item.type !== 'bot'"
                >
                  <v-avatar>
                    <img v-if="data.item.profilepicture" :src="data.item.profilepicture" class="object-fit-img">
                    <img v-else-if="data.item.type === 'company'" src='/static/img/default_profile/business-white.png' class="object-fit-img">
                    <img v-else-if="data.item.type === 'government'" src='/static/img/default_profile/business-white.png' class="object-fit-img">
                    <img v-else-if="data.item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="object-fit-img">
                    <img v-else src='/static/img/default_profile/man-white.png' class="object-fit-img">
                  </v-avatar>
                  <span class="text-overflow-chip">{{ data.item.name }}</span>
                </v-chip>
              </template>
              <template slot="item" slot-scope="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  <v-list-tile-avatar v-if="data.item.type !== 'bot'">
                    <img v-if="data.item.profilepicture" :src="data.item.profilepicture" class="object-fit-img">
                    <img v-else-if="data.item.type === 'company'" src='/static/img/default_profile/business-white.png' class="object-fit-img">
                    <img v-else-if="data.item.type === 'government'" src='/static/img/default_profile/business-white.png' class="object-fit-img">
                    <img v-else-if="data.item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="object-fit-img">
                    <img v-else src='/static/img/default_profile/man-white.png' class="object-fit-img">
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-if="data.item.type !== 'bot'" class="text-overflow">{{data.item.name}}</v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex sm4 md4 xl4 lg4 class="textSubject">
            <span>{{$t('Task.create.status')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top:20px;">
            <v-select
            :items="state"
            v-model="state_id"
            outlined
            hide-details
            item-text="name"
            item-value="state_id"
            style="padding:0; width: 25%;"
          ></v-select>
          </v-flex>
          <v-flex sm4 md4 xl4 lg4 class="textSubject">
            <span>{{$t('Task.create.checklist')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top:20px;">
            <v-layout row wrap align-start justify-start class="mr-1">
              <input type="text" :placeholder="$t('Task.create.placeholderChecklist')" class="CSChatThai inputchecklistweb" v-model="subject_checklist">
            </v-layout>
            <v-layout row wrap align-end justify-end class="mr-2">
              <v-btn class="btncreate-comment" @click="add_checklist()" :disabled="subject_checklist == ''">{{$t('AnswerQuestion.keep')}}</v-btn>
            </v-layout>
            <v-layout row wrap justify-center v-for="(item, index) in check_list" class="mt-2 border-checklist" v-if="item.disable != '1'">
              <div class="item">
                <input  @change="onModifyClick($event, index)" type="checkbox" :value="item.check" checked v-if="item.check == 'true'">
                <input  @change="onModifyClick($event, index)" type="checkbox" :value="item.check" v-else>
                <p v-if="item.check == 'true'">{{item.label}}</p>
                <p v-else>{{item.label}}</p>
                <v-btn color="grey" flat icon small slot="activator" @click="delete_checklist(item.id, index)">
                  <v-icon class="font-size15">fas fa-trash-alt</v-icon>
                </v-btn>
                <!-- <v-menu offset-y>
                  <v-btn color="black" flat icon small slot="activator">
                    <v-icon class="font-size20">more_vert</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile @click="delete_checklist(item.id, index)">
                      <v-list-tile-title>{{$t('Task.detail.menu.deletechecklist')}}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu> -->
              </div>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row wrap align-end justify-end class="mr-5" style="margin-top: 15px;">
          <v-btn class="btncancle" @click="cancel_task()">{{$t('AnswerQuestion.cancel')}}</v-btn>
          <v-btn class="btncreate" @click="edit_task()" :loading="isloading"
          :disabled="subject_task == '' || priority == undefined || start_date == '' || end_date == ''">{{$t('AnswerQuestion.keep')}}</v-btn>
        </v-layout>
      <!-- </v-layout> -->
    </v-card-text>

    <v-card-text v-else style="height: 70vh;" class="CSChatThai scrolling-wrapper">
      <v-layout justify-center align-center v-if="progress" style="height: 100% !important;">
        <v-progress-circular size="100" color="primary" :indeterminate="progress"></v-progress-circular>
      </v-layout>
      <v-layout row wrap class="mb-2" v-else>
        <v-flex d-flex sm2 md2 xl2 lg2>
          <v-icon style="margin-left: 10px;" :class="'btn-pri'+ priority" >mdi-checkbox-blank</v-icon>
        </v-flex>
        <v-flex d-flex sm10 md10 xl10 lg10>
          <v-layout row wrap>
            <v-flex sm12 md12 xl12 lg12>
              <h3 style="color: #003459; margin-right: 10px;">{{infor_task.title}}</h3>
            </v-flex>
            <v-flex sm12 md12 xl12 lg12>
              <v-chip class="ma-2" label text-color="white" small style="margin: 0 !important;!important; background: #e6ecf3 !important; color: #51819e !important; font-weight: 700;">
                {{state_name}}
              </v-chip>
              <span class="mb-0" style="font-size: 12px; color: #a6a6a6;" v-if="start_date || end_date">{{formatDate(start_date)}} <span v-if="start_date && end_date"> - </span> {{formatDate(end_date)}}
              </span>
            </v-flex>
          </v-layout>
        </v-flex>

          <v-flex sm12 md12 xl12 lg12 style="margin-top: 10px;" v-if="infor_task.detail">
            <div class="descriptionTask">
            <!-- <p class="mb-0 font-size-15">{{(infor_task.detail)? infor_task.detail: '-'}}</p> -->
            <read-more class="mb-0 font-size-15" :more-str="$t('ChatSide.Read.readmore')" :text="infor_task.detail ? infor_task.detail: '-'" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="100"></read-more>
            <v-btn small v-if="infor_task.sign_info != undefined" class="btn-sign-doc" @click="sign_doc(infor_task.sign_info)">{{infor_task.sign_info.label}}</v-btn>
          </div>
          </v-flex>

          <v-flex sm3 md3 xl3 lg3 class="textSubjectDetail">
            <span class="font-size-15">{{$t('Task.detail.createBy')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top: 15px !important;">
            <v-chip style="background: #e6ecf3 !important;">
            <v-avatar>
              <img :src="profilepicture" v-if="profilepicture" class="object-fit-img">
              <img src="/static/img/default_profile/man-white.png" v-else class="object-fit-img">
            </v-avatar>
            <span class="text-overflow-chip">
              {{nickname}}
            </span>
            </v-chip>
          </v-flex>
          <v-flex sm3 md3 xl3 lg3 class="textSubjectDetail">
            <span class="font-size-15">{{$t('Task.create.assign')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top: 15px !important;">
            <v-chip v-for="(item,index) in infor_task.assign" style="background: #e6ecf3 !important;">
            <v-avatar class="teal">
              <img :src="item.path_pic" v-if="item.path_pic" class="object-fit-img">
              <img src="/static/img/default_profile/man-white.png" v-else-if="item.type == 'user'" class="object-fit-img">
              <img src="/static/img/default_profile/bot-white.png" v-else-if="item.type == 'bot'" class="object-fit-img">
              <img src="/static/img/default_profile/man-white.png" v-else class="object-fit-img">
            </v-avatar>
            <span class="text-overflow-chip">
              {{item.nickname}}
            </span>
            </v-chip>
          </v-flex>
          <v-flex sm3 md3 xl3 lg3 class="textSubjectDetail" v-if="check_list.length != 0">
            <span>{{$t('Task.create.checklist')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top:20px;" v-if="check_list.length != 0">
            <v-layout row wrap justify-center v-for="(item, index) in check_list" class="mt-2 border-checklist" v-if="item.disable != '1'">
              <div class="item">
                <v-layout row wrap>
                  <v-icon v-if="item.check == 'true'" color="primary" class="font-size18" disabled>fas fa-check-square</v-icon>
                  <v-icon v-else color="primary" class="font-size18" disabled>far fa-square</v-icon>
                  <span class="ml-2 span-line" v-if="item.check == 'true'">{{item.label}}</span>
                  <span class="ml-2" v-else>{{item.label}}</span>
                </v-layout>
              </div>
            </v-layout>
          </v-flex>
          <v-flex sm3 md3 xl3 lg3 class="textSubjectDetail">
            <span class="font-size-16">{{$t('Task.create.comment')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top: 15px !important;">
            <v-layout row wrap class="mb-2" align-center justify-end>
              <v-textarea
                :label="$t('Task.create.placeholderComment')"
                solo
                no-resize
                style="width: 75%; margin-right: 10px; margin-top: 10px;"
                outline
                height="80"
                rows=3
                hide-details
                v-model="comment_task"
              ></v-textarea>
              <v-btn class="btncreate-comment" @click="add_comment()" :disabled="comment_task == ''">{{$t('AnswerQuestion.send')}}</v-btn>
            </v-layout>
            <v-layout column wrap>
              <v-card class="card-comment" v-for="(item, index) in listcomment">
                <v-layout row>
                  <v-flex xs1 sm1 md1 xl1 lg1 class="mt-3 ml-2">
                    <v-avatar size="40px">
                      <img :src="item.path_pic" alt="alt" v-if="item.path_pic" class="object-fit-img">
                      <img src="/static/img/default_profile/man-white.png" alt="alt" v-else class="object-fit-img">
                    </v-avatar>
                  </v-flex>
                  <v-flex xs9 sm9 md9 xl9 lg9>
                    <v-card-title primary-title>
                      <div class="ml-3">
                        <div class="text-overflow-comment">{{item.nickname}}</div>
                        <read-more style="width: 260px !important;" class="mb-0 mr-5" :more-str="$t('ChatSide.Read.readmore')" :text="item.comment" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="80"></read-more>
                      </div>
                    </v-card-title>
                  </v-flex>
                  <v-flex xs1 sm1 md1 xl1 lg1>
                    <!-- <v-menu offset-y> -->
                      <v-btn dark color="black" slot="activator" icon flat @click="delete_commemt(item.comment_id)">
                        <v-icon style="color: rgba(0,0,0,.87); font-size: 16px;">fas fa-trash</v-icon>
                      </v-btn>
                      <!-- <v-list>
                        <v-list-tile @click="delete_commemt(item.comment_id)">
                          <v-list-tile-title class="font-size-14">{{$t('Task.detail.menu.deletecommemt')}}</v-list-tile-title>
                        </v-list-tile>
                      </v-list> -->
                    <!-- </v-menu> -->
                  </v-flex>
                </v-layout>
              </v-card>
            </v-layout>
          </v-flex>

      </v-layout>
    </v-card-text>
    <WebviewBigDialog :dialogWebviewbig="dialogWebviewbig" :Webview_item="Webview_item" @closeWebview="closeWebview"></WebviewBigDialog>
  </v-card>
</v-dialog>
</template>
<script>
import { Decode } from '@/services'
import WebviewBigDialog from '@/components/chat/dialog/manage_chat/WebviewBigDialog'

var _ = require('lodash')
export default {
  props: {
    dialogDetailTask: false,
    taskid: '',
    roomid: ''
    // projectid: ''
  },
  components: {
    WebviewBigDialog
  },
  data: () => ({
    Webview_item: {},
    dialogWebviewbig: false,
    projectid: '',
    infor_task: {},
    edit: false,
    detail_task: '',
    token: '',
    subject_task: '',
    menu1: false,
    menu2: false,
    start_date: '',
    end_date: '',
    priority: null,
    member: [],
    selectemember: [],
    isloading: false,
    state: [],
    state_id: '',
    member: [],
    old_state: '',
    min_date: '',
    max_date: '',
    min_date_end: '',
    profilepicture: '',
    nickname: '',
    state_name: '',
    progress: false,
    listcomment: [],
    comment_task: '',
    check_list: [],
    check_list_start: [],
    subject_checklist: '',
    show: false
  }),
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
  },
  mounted () {
  },
  methods: {
    onModifyClick ({type, target}, index) {
      const event = {
          type,
          isCheckbox: target.type === 'checkbox',
          target: {
            value: target.value,
            checked: target.checked
          }
      }
      this.check_list[index].check = event.target.checked.toString()
      // this.check_list_start[index].check = !event.target.checked.toString()
      // console.log(!event.target.checked.toString())
      // console.log(this.check_list)
      // console.log(this.check_list_start)
    },
    clickedit () {
      this.edit = !this.edit
      this.show = false
    },
    delete_checklist (checklistid, index) {
      // console.log(checklistid, index)
      this.$swal({
        text: this.$t('Alert.Task.removeChecklist'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APIpub + '/v1/user/delete_checklist', {
            tokenuser: this.token,
            task_id: this.taskid,
            check_list_id: [checklistid]
          }).then((response) => {
            if (response.data.status == 'success') {
              this.check_list.splice(index, 1)
              // this.check_list = this.check_list
              this.get_task_by_id()
              this.$swal('', this.$t('Alert.Success.removeChecklist'), 'success')
            }
          }).catch(error => {
            console.log(error.message)
          })
        }
      })
    },
    add_checklist () {
      var listcheck = ''
      listcheck = { 'check': 'false', 'label': this.subject_checklist }
      this.axios.post(process.env.APIpub + '/v1/user/add_checklist', {
        tokenuser: this.token,
        task_id: this.taskid,
        check_list: [listcheck]
      }).then((response) => {
        if (response.data.status == 'success') {
          this.subject_checklist = ''
          // console.log(this.check_list)
          // console.log(response.data.data.check_list[0])
          this.$swal('', this.$t('Alert.Success.createChecklist'), 'success')
          this.check_list.unshift(response.data.data.check_list[0])
          // console.log(this.check_list)
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    get_comment () {
      this.axios.post(process.env.APIpub + '/v1/user/get_comment_by_id', {
        tokenuser: this.token,
        task_id: this.taskid
      }).then((response) => {
        // console.log(response.data.data)
        if (response.data.status == 'success') {
          this.listcomment = response.data.data
          this.listcomment = _.reverse(_.sortBy(this.listcomment, function (dateObj) {
            return new Date(dateObj.timestamp)
          }))
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    add_comment () {
      this.axios.post(process.env.APIpub + '/v1/user/comment_task', {
        tokenuser: this.token,
        task_id: this.taskid,
        comment: this.comment_task
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data.data)
          this.listcomment.unshift(response.data.data)
          this.$swal('', this.$t('Alert.Success.createComment'), 'success')
          this.comment_task = ''
          this.$emit('commenttask', { 'task_id': this.taskid, 'count_comment': this.listcomment.length, 'state_id': this.state_id, 'project_id': this.projectid })
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    delete_commemt (commentid) {
      this.$swal({
        text: this.$t('Alert.Task.removeComment'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APIpub + '/v1/user/delete_comment', {
            tokenuser: this.token,
          	comment_id: commentid
          }).then((response) => {
            if (response.data.status === 'success') {
              var index = ''
              index = _.findIndex(this.listcomment, function(o) { return o.comment_id == commentid })
              this.listcomment.splice(index, 1)
              this.$swal('', this.$t('Alert.Success.removeComment'), 'success')
              this.$emit('commenttask', { 'task_id': this.taskid, 'count_comment': this.listcomment.length, 'state_id': this.state_id, 'project_id': this.projectid })
            }
          }).catch(error => {
            console.log(error.message)
          })
        }
      })
    },
    sign_doc (item) {
      // console.log(item)
      // if (item.type == 'webview') {
      //   this.Webview_item = item
      //   this.dialogWebviewbig = true
      //   this.closeDialog()
      // } else if (item.type == 'link') {
      //   window.open(item.url, '_blank')
      // }
      if (item.sign == 'true') {
        this.getSign(item.url,item)
      } else {
        if (item.type === 'link') {
          window.open(item.url, '_blank')
        } else if (item.type === 'webview') {
          this.Webview_item = item
          this.dialogWebviewbig = true
          this.closeDialog()
        }
      }
    },
    getSign (url,item) {
      var body = {
       "tokenuser": this.token,
       "url": url
      }
      this.axios.post(process.env.APIpub + '/api/v1/getAccesstoken', body).then((response) => {
        item.url = response.data.data.url
        if (item.type === 'link') {
          window.open(item.url, '_blank')
        } else if (item.type === 'webview') {
          this.Webview_item = item
          this.dialogWebviewbig = true
        }
      }, () => {})
    },
    formatDate (input) {
      // console.log(input)
      if (input.match(/\d+/g) !== null && input.match(/\d+/g) !== 'null') {
        var datePart = input.match(/\d+/g),
        year = datePart[0].substring(2), // get only two digits
        month = datePart[1],
        day = datePart[2];
        return day+'/'+month+'/'+year;
      } else {
        return '-'
      }
    },
    closeWebview (value) {
      this.dialogWebviewbig = value
    },
    allowedDates (val) {
      this.min_date_end = this.start_date
      if (this.start_date > this.end_date) {
        this.end_date = this.start_date
      }
      return this.min_date_end
    },
    allowedDatesEnd (val) {
      this.min_date_end = this.start_date
      if (this.min_date_end > this.end_date) {
        this.end_date = this.min_date_end
      }
      return this.end_date
    },
    closeDialog () {
      this.check_list = []
      this.selectemember = []
      this.detail_task = ''
      this.subject_task = ''
      this.edit = false
      this.state_id = ''
      this.subject_checklist = ''
      this.$emit('closeDetailTask', false)
    },
    cancel_task () {
      this.start_date =  this.infor_task.time_start.split(' ')[0]
      this.end_date =  this.infor_task.time_end.split(' ')[0]
      this.edit = false
      this.isloading = false
      this.subject_checklist = ''
      this.get_task_by_id()
    },
    get_task_by_id () {
      this.progress = true
      this.axios.post(process.env.APIpub + '/v2/user/get_task_by_id', {
        tokenuser: this.token,
        task_id: this.taskid
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.infor_task = response.data.data
          this.check_list = _.reverse(this.infor_task.check_list)
        }
      }).catch(error => {
        // console.log(error.message)
        // console.log(error.response.data.message)
        if (error.response.data.message == 'Not found task.') {
          this.progress = false
          this.dialogDetailTask = false
          this.closeDialog()
          this.$swal('', this.$t('Alert.Fail.Task.removed'), 'warning')
        }
      })
    },
    edit_task () {
      // console.log(this.check_list)
      // var today = new Date();
      // var time = today.getHours() + "00:00:00" + today.getMinutes() + ":" + today.getSeconds();
      var time = "00:00:00.00"
      this.isloading = true
      this.axios.post(process.env.APIpub + '/v1/user/edit_task', {
        tokenuser: this.token,
        tokenroom: this.roomid,
      	title: this.subject_task,
      	detail: this.detail_task,
      	state_id: this.state_id,
      	time_start: this.start_date + ' ' + time,
      	time_end: this.end_date + ' ' + time,
      	priority: this.priority,
      	project_id: this.projectid,
      	assign: this.selectemember,
        task_id: this.taskid,
        check_list: this.check_list
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.isloading = false
          this.$swal('', this.$t('Alert.Success.editTask'), 'success')
          this.$emit('edittask', {'task_id': this.taskid, 'state_id': this.state_id, 'event': 'edit', 'old_state': this.old_state, 'date_end': this.end_date, 'project_id': this.projectid, 'date_start': this.start_date })
          this.closeDialog()
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    delete_task () {
      this.show = false
      this.$swal({
        text: this.$t('Alert.Task.remove'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APIpub + '/v1/user/delete_task', {
            tokenuser: this.token,
          	tokenroom: this.roomid,
          	list_task_id: [this.taskid]
          }).then((response) => {
            if (response.data.status === 'success') {
              // console.log(response.data.data)
              // console.log(this.taskid)
              this.isloading = false
              this.$swal('', this.$t('Alert.Success.removeTask'), 'success')
              this.$emit('deletetask', {'task_id': this.taskid, 'state_id': this.old_state, 'event': 'delete', 'project_id': this.projectid, 'date_end': this.infor_task.time_end })
              this.closeDialog()
            }
          }).catch(error => {
            console.log(error.message)
          })
        }
      })
    },
    get_member () {
      // console.log(this.roomid)
      this.axios.post(process.env.APImanage + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.roomid
      }).then((response) => {
        if (response.data.status === 'success') {
          var member_active = []
          member_active = response.data.data_room
          this.member = _.filter(member_active, function(o) { return o.type !== 'bot' && o.type !== 'business' && o.statemember == 'active' })
          this.member.push({
            tokenuser: this.token,
            name: localStorage.getItem('name'),
            profilepicture: localStorage.getItem('profilepicture')
          })
          // intersection เพราะเวลาที่มีคนออกจากกลุ่มแล้วทำให้แก้ไข task ไม่ได้
          this.selectemember = _.map(_.intersectionBy(this.member, this.infor_task.assign, 'tokenuser'), 'tokenuser')
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    getstate () {
      this.axios.post(process.env.APIpub + '/v1/user/get_state_by_project', {
        tokenuser: this.token,
        tokenroom: this.roomid,
        project_id: this.projectid
      }).then((response) => {
        this.state = response.data.data.state
        // this.state_id = response.data.data.state[0].state_id
      }).catch(error => {
        console.log(error.message)
      })
    },
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },
  watch: {
    dialogDetailTask () {
      // this.infor_task = {}
      if(this.dialogDetailTask) {
        this.progress = true
        this.infor_task = {}
        this.axios.post(process.env.APIpub + '/v1/user/get_task_by_id', {
          tokenuser: this.token,
          task_id: this.taskid
        }).then((response) => {
          // console.log(response.data.data)
          if (response.data.status === 'success') {
            this.progress = false
            this.infor_task = response.data.data
            // console.log(this.infor_task)
            this.old_state = this.infor_task.state.id
            this.state_id = this.infor_task.state.id
            this.check_list_start = this.infor_task.check_list
            this.check_list = _.reverse(this.infor_task.check_list)
            // this.check_list = _.sortBy(this.infor_task.check_list, [function(o) { return o.label }])
            // console.log(this.check_list)
            this.projectid = this.infor_task.project_id
            this.subject_task = this.infor_task.title
            this.priority = this.infor_task.priority
            this.start_date =  this.infor_task.time_start.split(' ')[0]
            this.end_date =  this.infor_task.time_end.split(' ')[0]
            this.detail_task = this.infor_task.detail
            this.profilepicture = this.infor_task.owner_info.path_pic
            this.nickname = this.infor_task.owner_info.nickname
            this.state_name = this.infor_task.state.name
            // this.selectemember = _.map(this.infor_task.assign, 'tokenuser')
            this.getstate()
            this.get_member()
            this.get_comment()
          }
        }).catch(error => {
          // console.log(error.message)
          // console.log(error.response.data.message)
          if (error.response.data.message == 'Not found task.') {
            this.progress = false
            this.dialogDetailTask = false
            this.closeDialog()
            this.$swal('', this.$t('Alert.Fail.Task.removed'), 'warning')
          }
        })
      }
    }
  }
}
</script>
<style type="text/css" scoped>
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.font-size15 {
  font-size: 15px !important;
}
.font-size20 {
  font-size: 20px !important;
}
.font-size18 {
  font-size: 18px !important;
}
.span-line {
  text-decoration: line-through !important;
}
/* .inbox {
  max-width: 400px;
  margin: 50px auto;
  background: white;
  border-radius: 5px;
  box-shadow: 10px 10px 0 rgba(0,0,0,0.1);
} */
.item {
  justify-content: start !important;
  width: 100% !important;
  display: flex !important;
  align-items: start !important;
  /* border-bottom: 1px solid #F1F1F1 !important; */
}
.item:last-child {
  border-bottom: 0;
}
input:checked + p {
  /* background: #F9F9F9; */
  text-decoration: line-through;
}
input[type="checkbox"] {
  margin: 15px;
}
p {
  margin: 0;
  padding-left: 10px;
  transition: background 0.2s;
  flex: 1;
  /* font-family:'helvetica neue'; */
  /* font-size: 20px; */
  font-weight: 200;
  border-left: 1px solid #D1E2FF;
  height: 100%;
  align-items: center !important;
  display: flex !important;
}
.border-checklist {
  border-style: solid !important;
  border-width: thin !important;
  border-radius: 5px !important;
  border-color: #e0e0e0 !important;
  padding: 5px !important;
}
.justifycenter {
  justify-content: center !important;
  display: flex !important;
}
>>>.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 4px !important;
}
>>>.v-label .theme--light {
  left: 0px !important;
  right: auto !important;
  position: relative !important;
  display: block !important;
}
/* p {
  margin-bottom: 0px !important;
  margin-right: 34px !important;
} */
.text-overflow-comment {
  font-weight: 600 !important;
  color: #003559 !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 240px !important;
}
.card-comment {
  /* height: 60px !important; */
  /* width: 370px !important; */
  width: 340px !important;
  border-radius: 6px !important;
  border-color: #e0e0e0 !important;
  border-style: solid !important;
  border-width: thin !important;
  box-shadow: none !important;
  margin-bottom: 5px !important;
  margin-right: 5px !important;
}
.btn-sign-doc {
  /*background-color: #1c78ec !important;*/
  background-color: white !important;
    /* width: 225px !important; */
    text-align: center;
    border-radius: 5px !important;
    color: #1c78ec !important;
    text-transform: none !important;
    border: 1px solid #1c78ec;
    box-shadow: none !important;
}
.font-size-15 {
  font-size: 15px !important;
}
.object-fit-img {
  object-fit: cover;
  object-position: 50% 0;
}
>>>.v-input .v-label {
  height: 25px !important;
  line-height: 24px !important;
}
>>>.v-text-field--outline .v-input__slot {
  min-height: 50px !important;
}
.system-bar {
  height: 2px !important;
  border-radius: 10px !important;
  width: 400px !important;
  margin-left: 55px !important;
  background-color: #d8d8d8 !important;
}
>>>.v-btn-toggle--selected {
  box-shadow: none !important;
}
.text-overflow-chip {
  /* margin-top: 10px !important; */
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 70px !important;
}
.text-overflow {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 250px !important;
}
.selectedPriority {
 border-radius: 5px;
 border: 1px solid #979797;
}
.btn-pri1 {
  /*width: 80px !important;*/
  color: #b3493d !important;
  font-size: 34px !important;
  /*border-radius: 4px !important;*/
}
.btn-pri2 {
  /*width: 80px !important;*/
  color: #fcbe55 !important;
  font-size: 34px !important;
  /*border-radius: 4px !important;*/
}
.btn-pri3 {
  /*width: 80px !important;*/
  color: #a0a1a3 !important;
  /*border-radius: 4px !important;*/
  font-size: 34px !important;
}
.btn-pri1-show {
  width: 60px !important;
  background-color: #b3493d !important;
  border-radius: 4px !important;
  height: 32px !important;
}
.btn-pri2-show {
  width: 60px !important;
  background-color: #fcbe55 !important;
  border-radius: 4px !important;
  height: 32px !important;
}
.btn-pri3-show {
  width: 60px !important;
  background-color: #a0a1a3 !important;
  border-radius: 4px !important;
  height: 32px !important;
}
>>>.v-input__slot {
  border-radius: 6px !important;
  /* border-color: #949494 !important;
  border-style: solid !important;
  border-width: thin !important; */
  border-width: thin !important;
  box-shadow: none !important;
}
.height-600px {
  height: 600px !important;
}
.toolbar-card {
  background-color: #1e2227 !important;
}
.toolbar-card-v2 {
  height: 64px !important;
  background-color: white !important;
}
.btncreate {
  font-size: 13px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 15px!important;
  /* background: #2562af !important; */
  background-image: linear-gradient(to right, rgb(66, 104, 251), rgb(113, 186, 200)) !important;
  color: white !important;
  width: 120px !important;
  text-transform: none;
}
.btncancle {
  font-size: 13px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 10px !important;
  background: #ffffff !important;
  color: #4268fb !important;
  width: 120px !important;
  border-style: solid !important;
  border-color: #4268fb !important;
  box-shadow: none !important;
  text-transform: none;
}
.text2 {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.close-classic:after {
  content: '×';
  font-size: 20px;
  /* ANSI X letter */
}

.containers {
  width: 454px;
  margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}
.listfile {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
  height: 135px !important;
  display: -webkit-inline-box !important;
  background: #f3f2f2 !important;
  padding-top: 17px !important;
  border-radius: 10px !important;
  margin-bottom: 15px !important;
  margin-top: 20px;
}

.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 140px !important;
  height: 100px !important;
  position: relative;
  background: white;
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
}

.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}

.application .theme--light.input-group input,
.application .theme--light.input-group textarea,
.theme--light .input-group input,
.theme--light .input-group textarea {
  /* color: rgba(0,0,0,.87); */
  color: #53ceff !important;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.user-photonote {
  height: 40px !important;
  width: 40px !important;
  background: #ccc;
  border-radius: 50%;
  overflow: hidden;

}
.text-transform {
  text-transform: capitalize !important;
}
.textchat {
  white-space: nowrap;
  max-width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-transform: none;
  display: inline-flex;
}

input[type=text] {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #b7b7b7;
  border-radius: 30px;
  font-size: 16px;
  background-color: white;
  background-image: url('/static/img/default_profile/group-white.png');
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 20px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}
input[type=text]:focus {
    outline: none !important;
}
>>>.v-input .v-label {
    height: 20px;
    line-height: 24px;
}
>>>.trix-content {
    height: 220px !important;
}
>>>trix-editor:empty:not(:focus)::before {
    content: attr(placeholder);
    color: #858585;
    font-size: 16px;
    cursor: text;
}
>>>.trix-button-group--file-tools {
  display: none;
}
.attachment_file {
  border-radius: 3px;
  border: #bbbbbb 1px solid;
  background: #eee;
  width: fit-content;
  padding-left: 5px;
  padding-right: 5px;
  display: inline-block;
}
>>>.inputtaskweb {
  color: black !important;
  font-size: 16px !important;
  height: 40px;
  width: 75% !important;
  border-radius: 5px !important;
  border: 1px #979797 solid !important;
}
.inputchecklistweb {
  color: black !important;
  font-size: 16px !important;
  height: 40px;
  width: 100% !important;
  border-radius: 5px !important;
  border: 1px #979797 solid !important;
}
.inputtaskwebDetail {
  color: black !important;
  font-size: 16px !important;
  height: 40px;
  width: 75% !important;
  border-radius: 5px !important;
  border: 1px #979797 solid !important;
  background: #e0e0e059 !important;
}
.textSubject {
  margin-top:20px;
  text-align: right;
  padding-right: 20px;
  font-size: 16px;
}
.textSubjectDetail {
  /* padding-left: 45px; */
  padding-left: 35px;
  margin-top:20px;
  color: #003459;
  font-weight: 600;
  font-size: 16px;
}
.btncreate-comment {
  font-size: 13px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 15px!important;
  background-image: linear-gradient(to right, rgb(66, 104, 251), rgb(113, 186, 200)) !important;
  color: white !important;
  width: 90px !important;
  text-transform: none;
}
input[type=text]:focus {
    outline: none !important;
}
textarea[type=text]:focus {
    outline: none !important;
}
.InputEdit {
    height: 43px;
    width: 100%;
    padding: 5px 15px !important;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
    margin-bottom: 15px !important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
    border: 1px #979797 solid;
}
.descriptionTask {
  border-radius: 5px;
  border: 1px solid #00345961;
  padding: 10px;
  width: 80%;
  margin-left: 45px;
}



.headerOut__dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  height: 4rem;
  min-width: 170px;
  overflow-y: auto;
  padding: 1rem 1rem 0rem 0;
  margin-top: 0rem;
  border-radius: 8px;
  background-color: white;
  border: 1px solid #dadce0;
  background-clip: padding-box;
}
.headerOut__dropdown-menu-link {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  line-height: 0;
  color: #3c4043;
  padding: 0.3rem 1.5rem 0.3rem 1.5rem;
  margin-bottom: 0.4rem;
  border-radius: 0 50px 50px 0;
}
.headerOut__dropdown-menu-link:hover {
  background-color: #b4d1f478;
  color: #2562af;
}
.headerOut__dropdown-menu-link:hover .headerOut--icon--menu {
  color: #2562af;
}
.headerOut__dropdown-menu-svg {
  padding-right: 16px;
}
.headerOut__dropdown-menu-svg.headerOut--icon {
  width: 1.40rem;
  height: 1.40rem;
}
.headerOut__dropdown-menu-svg.headerOut--icon--menu {
  width: 1.40rem;
  height: 1.40rem;
}


.header__dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  height: 25rem;
  min-width: 215px;
  overflow-y: auto;
  padding: 1rem 1rem 0rem 0;
  margin-top: 0rem;
  border-radius: 8px;
  background-color: white;
  border: 1px solid #dadce0;
  background-clip: padding-box;
}
.header__dropdown-menu-link {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  line-height: 0;
  color: #3c4043;
  padding: 0.3rem 1.5rem 0.3rem 1.5rem;
  margin-bottom: 0.4rem;
  border-radius: 0 50px 50px 0;
  width: 170px;
}
.header__dropdown-menu-link:hover {
  background-color: #b4d1f478;
  color: #2562af;
}
.header__dropdown-menu-link:hover .header--icon--menu {
  color: #2562af;
}
.header__dropdown-menu-svg {
  padding-right: 16px;
}
.header__dropdown-menu-svg.header--icon {
  width: 1.40rem;
  height: 1.40rem;
}
.header__dropdown-menu-svg.header--icon--menu {
  width: 1.40rem;
  height: 1.40rem;
}


.headerUser {
  margin-top: 4px;
}

.headerUser__nav {
  position: relative;
}
.headerUser__navbar {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
}
.headerUser__item {
  padding: 1rem;
  position: relative;
}
.headerUser--icon {
  font-size: 20px;
  color: black !important;
}
.headerUser--icon--menu {
  color: gray;
}
.headerUser--btn {
  top: 0;
  right: 0;
  position: absolute;
}
.headerUser--btn:focus {
  outline:none;
}
.headerUser--icon, .headerUser--icon--menu {
  fill: currentcolor;
  width: 1.65rem;
  height: 1.65rem;
  display: inline-flex;
}
.headerUser--btn {
  cursor: pointer;
  padding: 0;
  display: inline-block;
  border: 1px solid transparent;
  background-color: transparent;
  appearance: none;
  user-select: none;
}
.headerUser__dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  height: 7rem;
  width: 175px;
  overflow-y: auto;
  padding: 7px 1rem 0rem 0;
  margin-top: 0rem;
  border-radius: 8px;
  background-color: white;
  border: 1px solid #dadce0;
  background-clip: padding-box;
  /* justify-content: center; */
  display: flex;
  align-items: center;
}
.headerUser__dropdown-menu-link {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  line-height: 0;
  color: #3c4043;
  padding: 0.3rem 1.5rem 0.3rem 1.5rem;
  margin-bottom: 0.4rem;
  border-radius: 0 50px 50px 0;
}
.headerUser__dropdown-menu-link:hover {
  background-color: #b4d1f478;
  color: #2562af;
}
.headerUser__dropdown-menu-link:hover .headerUser--icon--menu {
  color: #2562af;
}
.headerUser__dropdown-menu-svg {
  padding-right: 16px;
}
.headerUser__dropdown-menu-svg.headerUser--icon {
  width: 1.40rem;
  height: 1.40rem;
}
.headerUser__dropdown-menu-svg.headerUser--icon--menu {
  width: 1.40rem;
  height: 1.40rem;
}

/*// Dropdown animation*/
.dropdown-enter-active, .dropdown-leave-active {
  transition: all 0.3s;
}
.dropdown-enter, .dropdown-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
.wrapper {
  height: 70vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.wrapper.social {
  margin-top: 1rem;
}
.wrapper a {
  padding: 0.6rem;
}
.wrapper h1 {
  color: #42b983;
  font-size: 2rem;
  font-weight: 300;
}
.wrapper p {
  color: #7f8c8d;
  font-weight: 100;
}
.wrapper svg {
  fill: currentcolor;
  color: #b8c2cc;
  width: 1.65rem;
  height: 1.65rem;
  display: inline-flex;
}
ul {
  margin: 0;
  padding: 0;
}

h1 { margin: 0 }
li { list-style: none; }
a { text-decoration: none; }

hr {
  border: 0;
  height: 0;
  margin: 5px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary {
  z-index: 8 !important;
}

>>>.v-text-field.v-text-field--solo .v-label {
  font-size: 14px;
}

>>>.v-textarea.v-text-field--enclosed.v-text-field--single-line .v-label {
    top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/manage_task/detail_task_dialog.vue